import { render, staticRenderFns } from "./MemberInfoPopup.vue?vue&type=template&id=519028b2&scoped=true&"
import script from "./MemberInfoPopup.vue?vue&type=script&lang=js&"
export * from "./MemberInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfoPopup.vue?vue&type=style&index=0&id=519028b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519028b2",
  null
  
)

export default component.exports